import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import SectionHeading from './SectionHeading';
import { useInView, reveal } from './motion';
import { useT } from '../../i18n/LanguageContext';

const getPoints = (t) => [
  {
    Icon: LockOutlinedIcon,
    title: t('home.privacyOwnership.point1Title'),
    body: t('home.privacyOwnership.point1Body'),
  },
  {
    Icon: DescriptionOutlinedIcon,
    title: t('home.privacyOwnership.point2Title'),
    body: t('home.privacyOwnership.point2Body'),
  },
  {
    Icon: CloudOffOutlinedIcon,
    title: t('home.privacyOwnership.point3Title'),
    body: t('home.privacyOwnership.point3Body'),
  },
];

function Point({ point, i }) {
  const theme = useTheme();
  const { ref, visible } = useInView();
  const { Icon } = point;
  return (
    <Box ref={ref} sx={{ ...reveal(visible, i * 0.1) }}>
      <Box sx={{
        width: 52, height: 52, borderRadius: '14px', display: 'grid', placeItems: 'center',
        bgcolor: '#fff', color: theme.home.cyanText, mb: 2.5,
        boxShadow: theme.home.softShadow || '0 6px 18px -10px rgba(20,24,29,0.28)',
      }}>
        <Icon fontSize="medium" />
      </Box>
      <Typography variant="h3" sx={{ fontSize: { xs: '1.3rem', md: '1.5rem' }, color: theme.home.ink, mb: 1.25 }}>
        {point.title}
      </Typography>
      <Typography sx={{ color: theme.home.inkMuted, lineHeight: 1.65, fontSize: '1.05rem' }}>
        {point.body}
      </Typography>
    </Box>
  );
}

export default function PrivacyOwnership() {
  const theme = useTheme();
  const t = useT();
  const points = getPoints(t);
  return (
    <Box id="privacy" sx={{ bgcolor: theme.home.paper, py: theme.home.sectionPy }}>
      <Box sx={{ maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 } }}>
        <SectionHeading
          eyebrow={t('home.privacyOwnership.eyebrow')}
          title={t('home.privacyOwnership.title')}
          lede={t('home.privacyOwnership.lede')}
        />
        <Box sx={{
          mt: { xs: 5, md: 8 }, display: 'grid', gap: { xs: 5, md: 6 },
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
        }}>
          {points.map((p, i) => <Point key={p.title} point={p} i={i} />)}
        </Box>
      </Box>
    </Box>
  );
}
